// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"f63fdcfe","179":"fb274bfb","570":"de5b6f37","766":"5d06e31b","950":"4055a6a6"}[chunkId] + ".chunk.js";
};